import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import {
  Dialog,
  Box,
  Typography,
  DialogContent,
  TextField,
  DialogActions,
  Button
} from "@material-ui/core";

import WarningRounded from "@material-ui/icons/WarningRounded";
import myStyles from "./Style";
import { FirebaseContext } from "../../FirebaseInit";

class DeleteUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      repassword: "",
      authenticated: "",
      loading: false
    };

    this.reAuth = this.reAuth.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  closeDialog(e) {
    this.setState({ authenticated: false });
    this.props.toggleDialog();
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  reAuth(user, firebase) {
    this.setState({ loading: true });
    user
      .reauthenticateWithCredential(
        firebase.auth.EmailAuthProvider.credential(
          user.email,
          this.state.repassword
        )
      )
      .then(() => {
        this.setState({ authenticated: true, loading: false });
      })
      .catch(error => {
        this.setState({ loading: false });

        this.props.toggleAlert(error.message, "error");
      });
  }

  deleteUser(user, firebase) {
    this.setState({ loading: true });

    const storageRef = firebase.strg().ref();
    const imgref = storageRef.child(`PPIC/${user.email}`);

    firebase
      .fs()
      .collection("users")
      .doc(user.uid)
      .get()
      .then(doc => {
        if (doc.exists) {
          firebase
            .fs()
            .collection("users")
            .doc(user.uid)
            .delete()
            .then(() => {
              imgref
                .delete()
                .then(() => {
                  user
                    .delete()
                    .then(() => {
                      this.setState({ loading: false });
                      this.props.toggleAlert("User deleted", "success");
                      this.props.userDeleted();
                    })
                    .catch(error => {
                      this.setState({ loading: false });

                      this.props.toggleAlert("Failed to delete user", "error");
                    });
                })
                .catch(err => {
                  if (err.code === "storage/object-not-found") {
                    user
                      .delete()
                      .then(() => {
                        this.setState({ loading: false });

                        this.props.toggleAlert("User deleted", "success");
                        this.props.userDeleted();
                      })
                      .catch(error => {
                        this.setState({ loading: false });

                        this.props.toggleAlert(
                          "Failed to delete user",
                          "error"
                        );
                      });
                  } else {
                    this.setState({ loading: false });
                    this.props.toggleAlert("Failed to delete user", "error");
                  }
                });
            })
            .catch(err => {
              this.setState({ loading: false });

              this.props.toggleAlert("Failed to delete user", "error");
            });
        } else {
          imgref
            .getDownloadURL()
            .then(url => {
              imgref
                .delete()
                .then(() => {
                  user
                    .delete()
                    .then(() => {
                      this.setState({ loading: false });

                      this.props.toggleAlert("User deleted", "success");
                      this.props.userDeleted();
                    })
                    .catch(error => {
                      this.setState({ loading: false });

                      this.props.toggleAlert("Failed to delete user", "error");
                    });
                })
                .catch(err => {
                  this.setState({ loading: false });

                  this.props.toggleAlert("Failed to delete user", "error");
                });
            })
            .catch(err => {
              if (err.code === "storage/object-not-found") {
                user
                  .delete()
                  .then(() => {
                    this.setState({ loading: false });

                    this.props.toggleAlert("User deleted", "success");
                    this.props.userDeleted();
                  })
                  .catch(error => {
                    this.setState({ loading: false });

                    this.props.toggleAlert("Failed to delete user", "error");
                  });
              }
            });
        }
      })
      .catch(err => {
        this.setState({ loading: false });

        this.props.toggleAlert("Failed to delete user", "error");
      });
  }

  render() {
    const { classes } = this.props;
    const firebase = this.context;
    return (
      <Dialog
        open={this.props.deleteDialog}
        maxWidth="xs"
        fullWidth
        onClose={this.closeDialog}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        style={{ zIndex: 1350 }}
      >
        <Box p={2} display="flex" alignItems="center" justifyContent="center">
          <WarningRounded fontSize="large" color="secondary" />
          <Typography variant="h5">Delete your account</Typography>
        </Box>
        <DialogContent dividers>
          <Box p={2}>
            {this.state.authenticated ? (
              <Typography variant="body1">
                This is a permanent action. You cannot recover your account
                after deleting it. Do you want to proceed?
              </Typography>
            ) : (
              <>
                <Typography variant="body1">
                  Please enter your password
                </Typography>
                <TextField
                  name="repassword"
                  required
                  fullWidth
                  margin="normal"
                  value={this.state.repassword}
                  onChange={this.handleChange}
                  disabled={this.state.loading}
                  variant="filled"
                  className={classes.unameInput}
                  type="password"
                  label="Password"
                  size="small"
                  autoFocus
                />
              </>
            )}
          </Box>
        </DialogContent>

        <DialogActions>
          {this.state.authenticated ? (
            <>
              <Button name="cancel" color="primary" onClick={this.closeDialog}>
                Cancel
              </Button>
              <Button
                onClick={this.deleteUser.bind(this, this.props.user, firebase)}
                color="secondary"
              >
                Delete my account
              </Button>
            </>
          ) : (
            <>
              <Button
                name="cancel"
                disabled={this.state.loading}
                onClick={this.props.toggleDialog}
                color="primary"
                variant="contained"
                size="small"
              >
                Cancel
              </Button>
              <Button
                disabled={this.state.loading}
                onClick={this.reAuth.bind(this, this.props.user, firebase)}
                color="secondary"
                variant="contained"
                size="small"
              >
                Authenticate
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>
    );
  }
}
DeleteUser.contextType = FirebaseContext;
export default withStyles(myStyles)(DeleteUser);
